import data from "./main_data";
export default {
    name: "app",
    data() {
        return {
            pixiMain: null,
            templateData: data,
            curTemplate: null,//当前粒子组件数据
            patternList: [
                {
                    value: "normal",
                    label: "正常模式"
                },
                {
                    value: "add",
                    label: "叠加模式"
                },
                {
                    value: "multiply",
                    label: "正片叠底模式"
                },
                {
                    value: "screen",
                    label: " 滤色模式"
                }
            ],
            colorList: [
                "#FFFFFF",
                "#FF5448",
                "#F2A653",
                "#FFCA28",
                "#18CFA1",
                "#59C7F9",
                "#4D8FF3",
                "#7171EF",
                "#4F5975",
                "#000000",
            ],
            alphaCollapse:""
        };
    },
    directives: {
        drag: {
            inserted(el) {
                let dragEl = el.firstChild;
                let width = window.innerWidth;
                let height = window.innerHeight;
                dragEl.addEventListener("mouseenter", event => {
                    event.target.style.cursor = "move";
                });
                dragEl.onmousedown = function (eve) {
                    let disx = eve.clientX - el.offsetLeft;
                    let disy = eve.clientY - el.offsetTop;
                    document.onmousemove = function (e) {
                        const moveX = e.clientX - disx,
                            maxX = width - el.offsetWidth;
                        const moveY = e.clientY - disy,
                            maxY = height - el.offsetHeight;
                        const left = moveX <= 0 ? "0px" : moveX >= maxX ? maxX + "px" : moveX + "px";
                        const top = moveY <= 0 ? "0px" : moveY >= maxY ? maxY + "px" : moveY + "px";
                        el.style.left = left;
                        el.style.top = top;
                    };
                    document.onmouseup = function () {
                        el.removeEventListener("mouseenter", () => {
                            this.style.cursor = "";
                        });
                        document.onmousemove = document.onmouseup = null;
                    };
                };
            }
        }
    },
    created() {
        this.curTemplate = this.templateData.page[0].element[0];
    },
    mounted() {
        this.$nextTick(() => {
            this.pixiMain = this.$refs.iframeItem.contentWindow;
        });
    },
    methods: {
        createEditor() {
            let timer = null;
            let handleFunction = () => {
                if (this.pixiMain) {
                    clearTimeout(timer);
                    if (this.templateData.width > this.templateData.height) {
                        this.pixiMain.Main.createApp(this.templateData, 888, 500);
                    } else {
                        this.pixiMain.Main.createApp(this.templateData, 500, 888);
                    }
                } else {
                    timer = setTimeout(handleFunction, 1000);
                }
            };
            handleFunction();
        },
        refreshData() {
            let value = this.curTemplate.styles.group[0].particleData;
            // console.log(value);
            if (!this.pixiMain) return;
            let root = this.pixiMain.EditorSupport.root;
            return root.refreshData("particleData", value);
        }
    },
    watch: {
        'curTemplate': {
            handler(val) {
                if (val) {
                    this.refreshData();
                }
            },
            deep: true
        }
    }
};